import { render, staticRenderFns } from "./NoDataFound.vue?vue&type=template&id=4e1d7eca&"
import script from "./NoDataFound.vue?vue&type=script&lang=js&"
export * from "./NoDataFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports